<p>base-configurables-list works!</p>
